module.exports = "../../app/cells/pages/rankings/subscriptions/show/articles_cell.rb";